export default __webpack_public_path__ + "static/media/fuel_filter.f2c65ad2.png";